import config from '@/config';
import axios from 'axios';
import { requests } from '.';
const MEDIA_SERVICE_URL = config === null || config === void 0 ? void 0 : config.MEDIA_SERVICE_URL;
export const MediaService = {
    initializeUpload: (data) => requests(MEDIA_SERVICE_URL).post('/files', data),
    uploadBlob: (url, blobData) => axios.put(url, blobData, {
        headers: {
            'Content-Type': 'image/jpeg',
        },
    }),
    finalizeUpload: (data) => requests(MEDIA_SERVICE_URL).post('/files/verify', data),
};
